// extracted by mini-css-extract-plugin
export default {"about_btn":"AboutLinkButton_about_btn__J6GhP"};